// App.jsx
import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import Header from "./components/H&F/Header.jsx";
import Footer from "./components/H&F/Footer.jsx";
import Login from "./components/Login/Login.jsx";
import Forgot from "./components/Login/Forgot.jsx";
import Support from "./Pages/Support.jsx";
import Ticketdashboard from "./Pages/Ticketdashboard.jsx";
import Ticketassign from "./components/Chat&assign/Ticketassign.jsx";
import Report from "./components/Menu/Report.jsx";
import Shift from "./components/Menu/Shift.jsx";
import Ticketrise from "./Pages/Ticketrise.jsx";

// ─── ProtectedRoute Component ────────────────────────────────────────────────
const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("userdetails"));

  localStorage.setItem("manualLogout", "true");

  const manualLogout = localStorage.getItem("manualLogout") === "true";
  if (!user) {
    if (!manualLogout) {
      alert("Session expired or not logged in. Redirecting to login.");
    }
    localStorage.removeItem("manualLogout"); // clear the flag
    return <Navigate to="/" replace />;
  }

  return children;
};

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // keep header button in sync
  useEffect(() => {
    const user = localStorage.getItem("userdetails");
    setIsLoggedIn(!!user);
  }, []);

  return (
    <div className="app">
      <Router>
        <Header isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} />

        <main className="main-content">
          <Routes>
            {/* public */}
            <Route path="/" element={<Login />} />
            <Route path="/Forgot" element={<Forgot />} />
            <Route path="/Ticketrise" element={<Ticketrise />} />

            {/* protected */}
            <Route
              path="/CA"
              element={
                <ProtectedRoute>
                  <Ticketassign />
                </ProtectedRoute>
              }
            />
            <Route
              path="/CM"
              element={
                <ProtectedRoute>
                  <Ticketdashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/SU"
              element={
                <ProtectedRoute>
                  <Support />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports"
              element={
                <ProtectedRoute>
                  <Report />
                </ProtectedRoute>
              }
            />
            <Route
              path="/shiftschedule"
              element={
                <ProtectedRoute>
                  <Shift />
                </ProtectedRoute>
              }
            />
          </Routes>
        </main>

        <Footer />
      </Router>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
      />
    </div>
  );
};

export default App;
